import {z} from 'zod'

import {apiFetch} from '../../api/fetch'
import {
    type CreateWorkerTypeInput,
    createWorkerTypeRequestSchema,
    type UpdateWorkerTypeInput,
    updateWorkerTypeRequestSchema,
    type WorkerType,
    workerTypeSchema,
} from './schemas'

export async function listWorkerTypes(): Promise<WorkerType[]> {
    const raw = await apiFetch<unknown>('/worker-types')
    return z.array(workerTypeSchema).parse(raw)
}

export async function getWorkerType(id: string): Promise<WorkerType> {
    const raw = await apiFetch<unknown>(`/worker-types/${id}`)
    return workerTypeSchema.parse(raw)
}

export async function createWorkerType(input: CreateWorkerTypeInput): Promise<WorkerType> {
    const body = createWorkerTypeRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/worker-types', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return workerTypeSchema.parse(raw)
}

export async function updateWorkerType(
    id: string,
    input: UpdateWorkerTypeInput,
): Promise<WorkerType> {
    const body = updateWorkerTypeRequestSchema.parse(input)
    const raw = await apiFetch<unknown>(`/worker-types/${id}`, {
        method: 'PUT',
        body: JSON.stringify(body),
    })
    return workerTypeSchema.parse(raw)
}
